import React from "react";
import { useStyles } from "./styles";

export const StatisticWidgetHeader = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.header} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidgetHeader.muiName = "StatisticWidgetHeader";
StatisticWidgetHeader.displayName = "StatisticWidgetHeader";

export default StatisticWidgetHeader;

export * from "./StatisticWidgetTitle";
export * from "./StatisticWidgetFilter";
